<template>
  <div class="align-center-main">
    <!-- 搜索结果 -->
    <section class="searchShow category" v-if="searchList.length" v-loading="loading">
      <ul class="content">
        <li v-for="(item, index) in searchList" :key="index" class="boxShadow" @click="$router.push({ path: `/shoppingMall/productDetalis` , query: { id:item.id, categoryId: item.categoryId}})">
          <img :src="item.thumb[0].img" alt="">
          <div class="title">
            <h4 class="textOver">{{ item.productName }}</h4>
            <p class="price"> ￥{{ item.price /100 | PriceFilter }} </p>
          </div>
        </li>
      </ul>
      <div class='pages main-pagination' v-if="pageTotal > 12">
        <el-pagination :page-size="12" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="pageTotal"></el-pagination>
      </div>
    </section>

    <section class="noSearchResult" v-if=" !searchList.length && !loading">
      <div>
        <i class="iconfont">&#xe619;</i>
        对不起，暂无此搜索内容!
      </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return{
      searchThings: '', //搜索框的文字
      searchList: [],   //搜索结果

      pageType: null,
      pageIndex: 1,
      pageTotal: 0,
      loading: true,

    }
  },
  computed: {
    ...mapGetters(['token', 'user']),
  },
  methods: {
    getSearchList() {
      this.loading = true;
      let params = {
        currPage: this.pageIndex,
        pageRows: 12,
        productName: this.searchThings,
      }
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/list`, params)
      .then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.searchList = res.resData.pageList ? res.resData.pageList : [];
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.$router.push({ path: '/shoppingMall/search', query: { searchThings: this.searchThings, page: val} });
      this.getSearchList();
    },
  },

  mounted() {
    this.searchThings = this.$route.query.searchThings
    this.getSearchList()
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.searchThings = this.$route.query.searchThings
        this.pageIndex = this.$route.query.page
        this.getSearchList()
      },
    },
  },
}

</script>

<style lang="scss" scoped>
// 搜索样式
.search{
  width: 1200px;
  // height: 182px;
  box-sizing: border-box;
  // background-color: #fff;
  padding: 30px 0;
  margin: 0 auto;
  .searchClassbox{
    float: left;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .searchipt{
    width: 1062px;
    height: 26px;
    padding: 5px 0;
    border: 1px solid #d9262c;
    outline: none;
    font-size: 16px;
    float: left;
  }
  .searchbtn{
    width: 136px;
    height: 38px;
    background-color: #d9262c;
    color: #fff;
    float: left;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
section {
  padding-top: 20px;
}
.noSearchResult{
  min-height: 400px;
  font-size: 24px;
  display: flex;
  align-items:center;
    justify-content: center;
  div{
    text-align: center;
    width: 400px;
    height: 42px;

    i{
      width: 40px;
      height: 40px;
      font-size: 28px;
    }
  }
}
// 展示列表
.category {
  min-height: 275px;
  margin-bottom: 20px;
  .content {
    overflow: hidden;
    li {
      float: left;
      width: 378px;
      height: 448px;
      margin-right: 20px;
      background-color: #fff;
      margin-bottom: 20px;
      .title {
        padding: 0 20px;
      }
      h4 {
        width: 100%;
        height: 24px;
        overflow: hidden;
        font-size: 18px;
        font-weight: 600;
        // margin-bottom: 10px;
        cursor: pointer;
      }
      .price {
        font-size: 20px;
        color: #de2c32;
      }
      img {
        width: 100%;
        height: 378px;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
.pages{
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}

//公共样式
.in_b{
  display: inline-block;
}
.red{
  background-color: #d9262c;
  color:#fff;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
.pageStyle{
  text-align: center;
  margin-top: 76px;
}

</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/components/search/Search.vue